module.exports = __webpack_public_path__ + "images/white_logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/white_logo.png
// module id = OYgD
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13